module.exports = __webpack_public_path__ + "img/converted.0cbc59db.png";